import React from 'react';
import { useLocation } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import Navigation from '../Navigation/Navigation';
import Footer from '../Footer/Footer';

const Layout = ({ children }) => {
  const location = useLocation();
  
  const hideLayout = [
    '/login',
    '/register',
    '/verify-email',
    '/forgot-password',
    '/reset-password'
  ].some(path => location.pathname.startsWith(path));

  return (
    <div className="app-layout">
      <Helmet>
        <meta
          http-equiv="Content-Security-Policy"
          content="default-src 'self'; script-src 'self' 'unsafe-inline' https://challenges.cloudflare.com; style-src 'self' 'unsafe-inline' https://fonts.googleapis.com; img-src 'self' data: blob: http://localhost:3000 http://localhost:3001 http://127.0.0.1:3000 http://127.0.0.1:3001 http://img.ferramentum.se https://img.ferramentum.se https:; font-src 'self' https://fonts.gstatic.com; connect-src 'self' https://challenges.cloudflare.com *; frame-src https://challenges.cloudflare.com;"
        />
      </Helmet>
      {!hideLayout && <Navigation />}
      <main className="main-content">
        {children}
      </main>
      {!hideLayout && <Footer />}
    </div>
  );
};

export default Layout;
